import { render, staticRenderFns } from "./PropertyAppointments.vue?vue&type=template&id=17b5301f&"
import script from "./PropertyAppointments.vue?vue&type=script&lang=js&"
export * from "./PropertyAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b5301f')) {
      api.createRecord('17b5301f', component.options)
    } else {
      api.reload('17b5301f', component.options)
    }
    module.hot.accept("./PropertyAppointments.vue?vue&type=template&id=17b5301f&", function () {
      api.rerender('17b5301f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/PropertyAppointments.vue"
export default component.exports